import type { BenchmarkFilters } from '@/types/domain'
import { api, guard, unwrap } from './client'

export const benchmarksApi = {
  summary: () => guard(async () => unwrap(await api.GET('/api/benchmark/summary'))),

  runs: (limit = 20) =>
    guard(async () => unwrap(await api.GET('/api/benchmark/runs', { params: { query: { limit } } }))),

  run: (runUid: string) =>
    guard(async () =>
      unwrap(await api.GET('/api/benchmark/runs/{run_uid}', { params: { path: { run_uid: runUid } } })),
    ),

  results: (runUid: string, filters: BenchmarkFilters) =>
    guard(async () =>
      unwrap(
        await api.GET('/api/benchmark/runs/{run_uid}/results', {
          params: {
            path: { run_uid: runUid },
            query: {
              outcome: filters.outcome,
              expected_tool: filters.expected_tool,
              category: filters.category,
              difficulty: filters.difficulty,
              limit: filters.limit,
              offset: filters.offset,
            },
          },
        }),
      ),
    ),
}
